import { useEffect } from 'react';
import { getEnv } from 'config';
import useScript from 'hooks/useScript';
import useStaticCallback from 'hooks/useStaticCallback';
import { GOOGLE_CLIENT_ID, GOOGLE_ONE_TAP_SCRIPT } from 'oauth/constants';

export interface UseGoogleOneTapConfig {
  /**
   * Called after successful authentication with Google
   */
  onSuccess: (token: string) => void;
}

export default function useGoogleOneTap({ onSuccess }: UseGoogleOneTapConfig) {
  const handleAuthSuccess = useStaticCallback(onSuccess);

  useScript({
    src: GOOGLE_ONE_TAP_SCRIPT,
    onStatusChange: (status) => {
      if (status === 'ready') {
        window.google?.accounts.id.initialize({
          client_id: getEnv(GOOGLE_CLIENT_ID),
          callback: ({ credential }) => {
            handleAuthSuccess(credential);
          },
        });

        window.google?.accounts.id.prompt();
      }
    },
  });

  useEffect(
    () => () => {
      window.google?.accounts.id.cancel();
    },
    [],
  );
}
